import { createContext, useContext, useEffect, useState } from 'react';

import { type TestTrack } from '@betterment-oss/test-track';

export interface FeatureFlagConfig {
  splitName: string;
  context: string;
  trueVariant?: string;
}

const TestTrackContext = createContext<Promise<TestTrack> | null>(null);

export const TestTrackProvider = TestTrackContext.Provider;

export const useFeatureFlag = ({ splitName, context, trueVariant }: FeatureFlagConfig) => {
  const testTrackPromise = useContext(TestTrackContext);

  const [isEnabled, setIsEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  if (!testTrackPromise) {
    throw new Error('useFeatureFlag must be used within a TestTrackProvider');
  }

  useEffect(() => {
    void testTrackPromise.then(testTrack => {
      const isFlagEnabled = testTrack.ab(splitName, {
        context,
        trueVariant,
      });

      setIsEnabled(isFlagEnabled);
      setIsLoading(false);
    });
  }, [context, splitName, trueVariant, testTrackPromise]);

  return { enabled: isEnabled, loading: isLoading };
};
